import React from 'react';
import { Outlet } from 'react-router-dom';

import MyDocuments from './MyDocuments';

export const MyDocumentsLayout = () => {
  return (
    <MyDocuments>
      <Outlet />
    </MyDocuments>
  );
};
